import company from './company'
import industry from './industry'
import salary from './salary'
import experience from './experience'
import education from './education'
import keyword from './keyword'

export default {
  [company.name]: company,
  [industry.name]: industry,
  [salary.name]: salary,
  [experience.name]: experience,
  [education.name]: education,
  [keyword.name]: keyword
}
